import { render } from "./ModalAddLocations.vue?vue&type=template&id=04880db2&scoped=true"
import script from "./ModalAddLocations.vue?vue&type=script&lang=js"
export * from "./ModalAddLocations.vue?vue&type=script&lang=js"

import "./ModalAddLocations.vue?vue&type=style&index=0&id=04880db2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04880db2"]])

export default __exports__